import { useCallback, useEffect, useRef } from 'react';

type TStartTimeoutFunc = (time: number, timeoutCallback: () => void) => void;

export function useTimeout(): {
  timeout: TStartTimeoutFunc;
  clear: () => void;
} {
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  const timeout = useCallback((time: number, timeoutCallback: () => void) => {
    timeoutId.current = setTimeout(() => {
      timeoutCallback();
      timeoutId.current = null;
    }, time);
  }, []);

  const clear = useCallback(() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
      timeoutId.current = null;
    }
  }, []);

  useEffect(
    () => () => {
      clear();
    },
    [clear],
  );

  return { timeout, clear };
}
